import { Provider } from '@angular/core';

import { ApiClient } from '../Domain/Adapter/api.client';
import { AnalyticsLaravelApiClientService } from '../Infrastructure/Port/analytics-laravel-api-client.service';

export const provideApiClient = (): Provider[] => {
    return [
        {
            provide: ApiClient,
            useExisting: AnalyticsLaravelApiClientService
        }
    ];
};
